import { env } from "@/config";
import { MOCK_CONTRACTOR_USER } from "@/pages/homepage/mock/contractor-user";
import { MOCK_HOMEOWNER_USER } from "@/pages/homepage/mock/homeowner-user";
import { MOCK_GUEST_USER } from "@/pages/homepage/mock/guest-user";
import type { ContractorUser, HomeownerUser, MeUser } from "../queries/useMe";

export function getUserComplements(
  user: HomeownerUser | ContractorUser
): UserComplements {
  return {
    get userType(): UserType | null {
      if (env.env === "LOCAL") {
        return getLocalUserType();
      }
      return user.userType;
    },
    get isHomeowner(): boolean {
      return this.userType === USER_TYPE.HOMEOWNER;
    },
    get isContractor(): boolean {
      return this.userType === USER_TYPE.CONTRACTOR;
    },
  };
}

export const USER_TYPE = {
  HOMEOWNER: "homeowner",
  CONTRACTOR: "contractor",
} as const;

export type UserType = (typeof USER_TYPE)[keyof typeof USER_TYPE];

export type UserComplements = {
  readonly userType: UserType | null;
  readonly isHomeowner: boolean;
  readonly isContractor: boolean;
};

export function getLocalUserType(): UserType | null {
  const userType = new URLSearchParams(window.location.search).get("user_type");
  if (userType === USER_TYPE.HOMEOWNER || userType === USER_TYPE.CONTRACTOR) {
    return userType;
  }

  return null;
}

export function getMockUser(): MeUser {
  const userType = getLocalUserType();
  if (userType === USER_TYPE.HOMEOWNER) {
    return MOCK_HOMEOWNER_USER;
  } else if (userType === USER_TYPE.CONTRACTOR) {
    return MOCK_CONTRACTOR_USER;
  }
  return MOCK_GUEST_USER;
}
